/* eslint-disable max-lines -- not split yet: booking, equipment, tire hotel, tire spec and worker option groups are separable */
import {
  AuditLogAction,
  BookingCancellationReason,
  BookingCancellationReasonLabels,
  BookingCancellationSource,
  BookingCancellationSourceLabels,
  BookingEventSource,
  BookingEventSourceLabels,
  BookingEventType,
  BookingEventTypeLabels,
  BookingLocationType,
  BookingLocationTypeLabels,
  BookingProposalSMSType,
  BookingProposalStatus,
  BookingProposalStatusLabels,
  BookingProposalType,
  BookingProposalTypeLabels,
  BookingSMSType,
  BookingStatus,
  BookingStatusLabels,
  CapacityContributionLocationType,
  CapacityContributionLocationTypeLabels,
  CapacityContributionStatus,
  CapacityContributionStatusLabels,
  CapacityContributionType,
  CarWheelMeasurementType,
  CarWheelMeasurementTypeLabels,
  Country,
  CountryLabels,
  Currency,
  CurrencyLabels,
  CustomerContractStatus,
  CustomerContractStatusDescriptions,
  CustomerContractStatusLabels,
  CustomerContractType,
  CustomerContractTypeLabels,
  CustomerGroupType,
  CustomerGroupTypeLabels,
  CustomerSegment,
  CustomerSegmentLabels,
  EmailProvider,
  EmailProviderLabels,
  EmailStatus,
  EmailStatusLabels,
  EmailTemplate,
  EmailTemplateLabels,
  EquipmentAuditStatus,
  EquipmentAuditStatusLabels,
  EquipmentCategory,
  EquipmentCategoryLabels,
  EquipmentItemStatus,
  EquipmentItemStatusLabels,
  EquipmentMovementAction,
  EquipmentMovementActionLabels,
  EquipmentPurchasePlanStatus,
  EquipmentPurchasePlanStatusLabels,
  EquipmentPurchasePlanType,
  EquipmentPurchasePlanTypeLabels,
  EquipmentSizeCategory,
  EquipmentSizeCategoryLabels,
  EquipmentTrackingMethod,
  EquipmentTrackingMethodLabels,
  EquipmentTransferStatus,
  EquipmentTransferStatusLabels,
  FleetAutoBookingSkipReason,
  FleetAutoBookingSkipReasonLabels,
  FulfillmentIssueStatus,
  FulfillmentIssueStatusLabels,
  FulfillmentIssueType,
  FulfillmentIssueTypeLabels,
  InspectionContext,
  InspectionContextLabels,
  InspectionPurpose,
  InspectionPurposeLabels,
  InspectionSource,
  InspectionSourceLabels,
  InventoryCatalogChannel,
  InventoryCatalogChannelLabels,
  InventoryOrderStatus,
  InventoryOrderStatusLabels,
  LabelPrintReason,
  LanguageCode,
  LanguageCodeLabels,
  LeadCloseReason,
  LeadCloseReasonLabels,
  LeadGenerationType,
  LeadGenerationTypeLabels,
  LeadStage,
  LeadStageLabels,
  type MimeType as NsdkMimeType,
  OrderPaymentStatus,
  OrderPaymentStatusLabels,
  OrderStatus,
  OrderStatusLabels,
  OrderTransactionStatus,
  OrderTransactionStatusLabels,
  OutboundWebhookEventType,
  OutboundWebhookEventTypeLabels,
  PaymentOption,
  PayrollStatus,
  PayrollStatusLabels,
  PersonalAccountPurpose,
  PersonalAccountPurposeLabels,
  PersonalInfoReviewSection,
  PersonalInfoReviewSectionLabels,
  PhoneNumberCountry,
  PhoneNumberCountryLabels,
  PhoneNumberType,
  PhoneNumberTypeLabels,
  PrincipalType,
  PrincipalTypeLabels,
  QuoteStatus,
  RecallCapacityMode,
  RecallCapacityModeLabels,
  RecallType,
  RecallTypeLabels,
  RimColorFinish,
  RimColorFinishLabels,
  RimItemNote,
  RimItemNoteLabels,
  RuleSetCategory,
  RuleSetCategoryLabels,
  SalesItemAddonQuantityMode,
  SalesItemAddonQuantityModeLabels,
  SalesItemBookingChannel,
  SalesItemBookingChannelLabels,
  SalesItemCatalogType,
  SalesItemCatalogTypeLabels,
  SalesItemCategory,
  SalesItemCategoryLabels,
  SalesItemTagIcon,
  SalesItemTagIconLabels,
  SalesItemTagType,
  SalesItemTagTypeLabels,
  SalesItemType,
  SalesItemTypeLabels,
  ScopeType,
  ScopeTypeLabels,
  ServiceDepartmentModule,
  ServiceDepartmentModuleLabels,
  ServiceDepartmentStatus,
  ServiceDepartmentStatusLabels,
  ServiceWorkerAbsenceStatus,
  ServiceWorkerAbsenceStatusLabels,
  ServiceWorkerAbsenceType,
  ServiceWorkerAbsenceTypeDescriptions,
  ServiceWorkerAbsenceTypeLabels,
  ServiceWorkerContractEmploymentType,
  ServiceWorkerSMSType,
  ShopSupplierType,
  ShopSupplierTypeLabels,
  SoundClass,
  SoundClassLabels,
  StorageCustody,
  StorageCustodyLabels,
  StorageTransferOrderItemUnableToCompleteReason,
  StorageTransferOrderItemUnableToCompleteReasonLabels,
  StorageTransferOrderStatus,
  StorageTransferOrderStatusLabels,
  StorageUnitType,
  StorageUnitTypeLabels,
  SupplierProductStatus,
  SupplierProductStatusLabels,
  SupportScheduleCadence,
  SupportScheduleCadenceLabels,
  SupportScheduleSelectionStrategy,
  SupportScheduleSelectionStrategyLabels,
  TaskType,
  TaskTypeLabels,
  TimeZone,
  TimeZoneLabels,
  TireClassEU,
  TireClassEULabels,
  TireClassification,
  TireClassificationLabels,
  TireConstructionType,
  TireConstructionTypeLabels,
  TireHotelRehomeSellerMembershipOutcome,
  TireHotelRehomeSellerMembershipOutcomeLabels,
  TireHotelRehomeSettlement,
  TireHotelRehomeSettlementLabels,
  TireHotelRehomeStatus,
  TireHotelRehomeStatusLabels,
  TireHotelSellerInboundMode,
  TireHotelSellerInboundModeLabels,
  TireHotelWheelSetStatus,
  TireHotelWheelSetStatusDescriptions,
  TireHotelWheelSetStatusLabels,
  TireLoadIndex,
  TireLoadIndexLabels,
  TireQuoteSMSType,
  TireRollingResistanceClass,
  TireRollingResistanceClassLabels,
  TireSeason,
  TireSeasonLabels,
  TireSpeedIndex,
  TireSpeedIndexLabels,
  TwilioStatusCode,
  UnableToCompleteReasonCatalogType,
  UnableToCompleteReasonCatalogTypeLabels,
  UserGroupSMSType,
  UserRole,
  UserRoleLabels,
  VehicleCategory,
  VehicleCategoryLabels,
  WetGripClass,
  WetGripClassLabels,
  WorkerShiftMode,
  WorkerShiftModeLabels
} from '@navio/nsdk';
import { UnableToCompleteStatus, unableToCompleteStatusToLabel } from 'noddi-types';
import { countryCodeToFlag } from '../locale/countryCodeToFlag';
import { CUSTOMER_SEGMENT_ICON_MAP } from '../userGroup';
import {
  constObjectToOptions,
  constObjectToSentenceCaseOptions,
  entriesToOptions,
  enumToOptions,
  getLabelMapFromEntries
} from './choiceOptions';
import { TIRE_SEASON_ICON } from './tireSeason';

// Booking
export const BOOKING_STATUS_OPTIONS = enumToOptions(BookingStatus, BookingStatusLabels);

/**
 * Statuses staff never see. Both are pre-commitment: a booking a customer
 * abandoned mid-checkout is noise on a back-office overview, while
 * ADMIN_CREATED_PAYMENT_REQUESTED is the state staff must chase.
 */
const BOOKING_STATUSES_HIDDEN_FROM_BACKOFFICE: BookingStatus[] = [BookingStatus.DRAFT, BookingStatus.DRAFT_PAY_BEFORE];

/** Status filter choices for the back-office apps. */
export const BOOKING_STATUS_OPTIONS_BACKOFFICE = BOOKING_STATUS_OPTIONS.filter(
  (option) => !BOOKING_STATUSES_HIDDEN_FROM_BACKOFFICE.includes(option.value)
);
export const BOOKING_LOCATION_TYPE_OPTIONS = entriesToOptions(BookingLocationType, BookingLocationTypeLabels);
export const BOOKING_EVENT_TYPE_OPTIONS = entriesToOptions(BookingEventType, BookingEventTypeLabels);
export const BOOKING_EVENT_SOURCE_OPTIONS = entriesToOptions(BookingEventSource, BookingEventSourceLabels);
const BOOKING_EVENT_SOURCE_LABELS: Record<string, string> = getLabelMapFromEntries(
  BookingEventSource,
  BookingEventSourceLabels
);
/** Label for an X-Navio-Source value; unknown values (partner integrations) are shown as sent. */
export const getBookingEventSourceLabel = (source: string): string => BOOKING_EVENT_SOURCE_LABELS[source] ?? source;
export const BOOKING_CANCELLATION_SOURCE_OPTIONS = entriesToOptions(
  BookingCancellationSource,
  BookingCancellationSourceLabels
);
export const BOOKING_CANCELLATION_REASON_LABELS = getLabelMapFromEntries(
  BookingCancellationReason,
  BookingCancellationReasonLabels
);
export const BOOKING_PROPOSAL_TYPE_OPTIONS = entriesToOptions(BookingProposalType, BookingProposalTypeLabels);
export const BOOKING_PROPOSAL_STATUS_OPTIONS = entriesToOptions(BookingProposalStatus, BookingProposalStatusLabels);
export const RECALL_TYPE_OPTIONS = entriesToOptions(RecallType, RecallTypeLabels);

export const RECALL_CAPACITY_MODE_OPTIONS = entriesToOptions(RecallCapacityMode, RecallCapacityModeLabels);

export const UNABLE_TO_COMPLETE_STATUS_OPTIONS = constObjectToOptions(
  UnableToCompleteStatus,
  unableToCompleteStatusToLabel
);

// Order
export const ORDER_STATUS_OPTIONS = enumToOptions(OrderStatus, OrderStatusLabels);
export const ORDER_TRANSACTION_STATUS_OPTIONS = enumToOptions(OrderTransactionStatus, OrderTransactionStatusLabels);
export const ORDER_PAYMENT_STATUS_OPTIONS = entriesToOptions(OrderPaymentStatus, OrderPaymentStatusLabels);

// Equipment
export const EQUIPMENT_CATEGORY_OPTIONS = entriesToOptions(EquipmentCategory, EquipmentCategoryLabels);
export const EQUIPMENT_CATEGORY_LABEL_MAP = getLabelMapFromEntries(EquipmentCategory, EquipmentCategoryLabels);
export const EQUIPMENT_ITEM_STATUS_OPTIONS = entriesToOptions(EquipmentItemStatus, EquipmentItemStatusLabels);
export const EQUIPMENT_ITEM_STATUS_LABEL_MAP = getLabelMapFromEntries(EquipmentItemStatus, EquipmentItemStatusLabels);
export const EQUIPMENT_TRACKING_METHOD_OPTIONS = entriesToOptions(
  EquipmentTrackingMethod,
  EquipmentTrackingMethodLabels
);
export const EQUIPMENT_TRACKING_METHOD_LABEL_MAP = getLabelMapFromEntries(
  EquipmentTrackingMethod,
  EquipmentTrackingMethodLabels
);
export const EQUIPMENT_SIZE_CATEGORY_OPTIONS = entriesToOptions(EquipmentSizeCategory, EquipmentSizeCategoryLabels);
export const EQUIPMENT_SIZE_CATEGORY_LABEL_MAP = getLabelMapFromEntries(
  EquipmentSizeCategory,
  EquipmentSizeCategoryLabels
);
export const EQUIPMENT_MOVEMENT_ACTION_LABEL_MAP = getLabelMapFromEntries(
  EquipmentMovementAction,
  EquipmentMovementActionLabels
);
export const EQUIPMENT_TRANSFER_STATUS_OPTIONS = entriesToOptions(
  EquipmentTransferStatus,
  EquipmentTransferStatusLabels
);
export const EQUIPMENT_TRANSFER_STATUS_LABEL_MAP = getLabelMapFromEntries(
  EquipmentTransferStatus,
  EquipmentTransferStatusLabels
);
export const EQUIPMENT_AUDIT_STATUS_OPTIONS = entriesToOptions(EquipmentAuditStatus, EquipmentAuditStatusLabels);
export const EQUIPMENT_AUDIT_STATUS_LABEL_MAP = getLabelMapFromEntries(
  EquipmentAuditStatus,
  EquipmentAuditStatusLabels
);
export const EQUIPMENT_PURCHASE_PLAN_STATUS_OPTIONS = entriesToOptions(
  EquipmentPurchasePlanStatus,
  EquipmentPurchasePlanStatusLabels
);
export const EQUIPMENT_PURCHASE_PLAN_STATUS_LABEL_MAP = getLabelMapFromEntries(
  EquipmentPurchasePlanStatus,
  EquipmentPurchasePlanStatusLabels
);
export const EQUIPMENT_PURCHASE_PLAN_TYPE_OPTIONS = entriesToOptions(
  EquipmentPurchasePlanType,
  EquipmentPurchasePlanTypeLabels
);
export const EQUIPMENT_PURCHASE_PLAN_TYPE_LABEL_MAP = getLabelMapFromEntries(
  EquipmentPurchasePlanType,
  EquipmentPurchasePlanTypeLabels
);

// Inventory order
export const INVENTORY_ORDER_STATUS_OPTIONS = entriesToOptions(InventoryOrderStatus, InventoryOrderStatusLabels);

// Longer than the backend labels: the print list names what each label is for.
export const LABEL_PRINT_REASON_LABELS = {
  [LabelPrintReason.RELOAD_PICKUP]: 'Labels for wheel sets picked up on route',
  [LabelPrintReason.LABEL_DAMAGED]: 'Replace damaged label',
  [LabelPrintReason.INVENTORY_RECEIVED]: 'New tires received from supplier',
  [LabelPrintReason.MOUNTING]: 'Labels lost during tire mounting',
  [LabelPrintReason.TIRE_HOTEL_REHOME]: 'Wheel set moved to new owner',
  [LabelPrintReason.NEEDS_NEW_LABEL]: 'Label no longer matches the wheel set',
  [LabelPrintReason.MANUAL]: 'Sent manually'
} as const satisfies Record<LabelPrintReason, string>;
export const LABEL_PRINT_REASON_OPTIONS = entriesToOptions(LabelPrintReason, LABEL_PRINT_REASON_LABELS);

// Storage transfer order
const STORAGE_TRANSFER_ORDER_STATUS_OPTIONS = entriesToOptions(
  StorageTransferOrderStatus,
  StorageTransferOrderStatusLabels
);

/** Partner/worker list filter — drafts are composition-only and omitted from the picker. */
export const STORAGE_TRANSFER_ORDER_PARTNER_STATUS_FILTER_OPTIONS = STORAGE_TRANSFER_ORDER_STATUS_OPTIONS.filter(
  (option) => option.value !== StorageTransferOrderStatus.DRAFT
);

export const STORAGE_TRANSFER_ORDER_ITEM_UNABLE_TO_COMPLETE_REASON_OPTIONS = entriesToOptions(
  StorageTransferOrderItemUnableToCompleteReason,
  StorageTransferOrderItemUnableToCompleteReasonLabels
);
export const STORAGE_CUSTODY_OPTIONS = entriesToOptions(StorageCustody, StorageCustodyLabels);
export const STORAGE_UNIT_TYPE_OPTIONS = entriesToOptions(StorageUnitType, StorageUnitTypeLabels);

// Brand
// Listed in dialog order, not alphabetically, so the multi-select reads the way customers see it.
export const PERSONAL_INFO_REVIEW_SECTION_OPTIONS = entriesToOptions(PersonalInfoReviewSection, {
  CONTACT: PersonalInfoReviewSectionLabels.CONTACT,
  CARS: PersonalInfoReviewSectionLabels.CARS,
  ADDRESSES: PersonalInfoReviewSectionLabels.ADDRESSES
});
export const PERSONAL_ACCOUNT_PURPOSE_OPTIONS = entriesToOptions(PersonalAccountPurpose, PersonalAccountPurposeLabels);

// Service department
export const SERVICE_DEPARTMENT_STATUS_OPTIONS = entriesToOptions(
  ServiceDepartmentStatus,
  ServiceDepartmentStatusLabels
);
export const SERVICE_DEPARTMENT_MODULE_OPTIONS = entriesToOptions(
  ServiceDepartmentModule,
  ServiceDepartmentModuleLabels
);
export const WORKER_SHIFT_MODE_OPTIONS = entriesToOptions(WorkerShiftMode, WorkerShiftModeLabels);

// Sales item
export const SALES_ITEM_CATEGORY_OPTIONS = entriesToOptions(SalesItemCategory, SalesItemCategoryLabels);
export const SALES_ITEM_CATALOG_TYPE_OPTIONS = entriesToOptions(SalesItemCatalogType, SalesItemCatalogTypeLabels);
export const SALES_ITEM_TYPE_OPTIONS = entriesToOptions(SalesItemType, SalesItemTypeLabels);
export const SALES_ITEM_BOOKING_CHANNEL_OPTIONS = entriesToOptions(
  SalesItemBookingChannel,
  SalesItemBookingChannelLabels
);
export const SALES_ITEM_ADDON_QUANTITY_MODE_OPTIONS = entriesToOptions(
  SalesItemAddonQuantityMode,
  SalesItemAddonQuantityModeLabels
);
export const SALES_ITEM_TAG_ICON_OPTIONS = entriesToOptions(SalesItemTagIcon, SalesItemTagIconLabels);
export const SALES_ITEM_TAG_TYPE_OPTIONS = entriesToOptions(SalesItemTagType, SalesItemTagTypeLabels);

/**
 * Maps backend SalesItemTagIcon values (SNAKE_CASE) to NoddiIcon names (PascalCase).
 * Built dynamically from the SalesItemTagIcon enum so new backend icons are picked up automatically.
 * E.g. "MAP_PIN" → "MapPin", "HAND_COINS" → "HandCoins", "GRID_2X2" → "Grid2X2"
 */
export const SALES_ITEM_TAG_ICON_TO_NODDI_ICON: Record<string, string> = Object.fromEntries(
  Object.values(SalesItemTagIcon).map((iconKey) => [
    iconKey,
    iconKey
      .split('_')
      .map((segment) => (/^\d/.test(segment) ? segment : segment.charAt(0) + segment.slice(1).toLowerCase()))
      .join('')
  ])
);

// Unable to complete reason catalog
export const UNABLE_TO_COMPLETE_REASON_CATALOG_TYPE_OPTIONS = entriesToOptions(
  UnableToCompleteReasonCatalogType,
  UnableToCompleteReasonCatalogTypeLabels
);

export const UNABLE_TO_COMPLETE_REASON_CATALOG_TYPE_TOOLTIP =
  'Default reasons are applied to all service organizations by default. Opt-in reasons can be added by service organizations.';

/** Map from catalog type value to display label (e.g. for badges and read-only display). */
export const UNABLE_TO_COMPLETE_REASON_CATALOG_TYPE_LABEL_BY_VALUE: Record<
  (typeof UnableToCompleteReasonCatalogType)[keyof typeof UnableToCompleteReasonCatalogType],
  string
> = {
  [UnableToCompleteReasonCatalogType.DEFAULT]: UnableToCompleteReasonCatalogTypeLabels.DEFAULT,
  [UnableToCompleteReasonCatalogType.OPT_IN]: UnableToCompleteReasonCatalogTypeLabels.OPT_IN
};

// Supplier
export const SUPPLIER_PRODUCT_STATUS_OPTIONS = entriesToOptions(SupplierProductStatus, SupplierProductStatusLabels);
export const INVENTORY_CATALOG_CHANNEL_OPTIONS = entriesToOptions(InventoryCatalogChannel, {
  ...InventoryCatalogChannelLabels,
  [InventoryCatalogChannel.EONTYRE]: 'Resold via adapter'
});
export const FULFILLMENT_ISSUE_STATUS_OPTIONS = entriesToOptions(FulfillmentIssueStatus, FulfillmentIssueStatusLabels);
export const FULFILLMENT_ISSUE_TYPE_OPTIONS = entriesToOptions(FulfillmentIssueType, FulfillmentIssueTypeLabels);
export const SHOP_SUPPLIER_TYPE_OPTIONS = entriesToOptions(ShopSupplierType, ShopSupplierTypeLabels);
export const SHOP_SUPPLIER_TYPE_LABEL_MAP = getLabelMapFromEntries(ShopSupplierType, ShopSupplierTypeLabels);

// Location & time
export const COUNTRY_OPTIONS = entriesToOptions(Country, CountryLabels).map((option) => {
  const flag = countryCodeToFlag(option.value);
  return {
    ...option,
    label: flag ? `${flag} ${option.label}` : option.label
  };
});
export const TIME_ZONE_OPTIONS = entriesToOptions(TimeZone, TimeZoneLabels);

// Organization & user group
export const CUSTOMER_GROUP_TYPE_OPTIONS = entriesToOptions(CustomerGroupType, CustomerGroupTypeLabels);
export const SCOPE_TYPE_OPTIONS = entriesToOptions(ScopeType, ScopeTypeLabels);
export const SCOPE_TYPE_LABEL_MAP = getLabelMapFromEntries(ScopeType, ScopeTypeLabels);
export const PRINCIPAL_TYPE_OPTIONS = entriesToOptions(PrincipalType, PrincipalTypeLabels);
export const PRINCIPAL_TYPE_LABEL_MAP = getLabelMapFromEntries(PrincipalType, PrincipalTypeLabels);
const CUSTOMER_SEGMENT_DESCRIPTION_MAP = {
  [CustomerSegment.ALL]: 'Every customer linked to the service department through a booking or tire quote.',
  [CustomerSegment.PROSPECTS]: 'No bookings at this service department. May still have tire quotes.',
  [CustomerSegment.NEW_CUSTOMER]: 'Exactly one completed booking, or the first booking is still in progress.',
  [CustomerSegment.ACTIVE_CLIENTS]: '2-9 completed bookings, with the last completed service within the past 7 months.',
  [CustomerSegment.VIP]:
    '10+ completed bookings or lifetime spend of at least NOK 25,000, and last completed service within the past 7 months.',
  [CustomerSegment.AT_RISK]:
    '2+ completed bookings, with the last completed service 7-13 months ago (about one missed seasonal wheel change).',
  [CustomerSegment.CHURNED]:
    '2+ completed bookings, with the last completed service 14+ months ago (about two missed seasons).',
  [CustomerSegment.FLEET_MANAGER]: '3 or more currently registered cars. Takes priority over the other segments.'
} as const satisfies Record<CustomerSegment, string>;
export const CUSTOMER_SEGMENT_OPTIONS = entriesToOptions(CustomerSegment, CustomerSegmentLabels).map((option) => ({
  ...option,
  icon: CUSTOMER_SEGMENT_ICON_MAP[option.value],
  description: CUSTOMER_SEGMENT_DESCRIPTION_MAP[option.value]
}));
export const CUSTOMER_SEGMENT_LABEL_MAP = getLabelMapFromEntries(CustomerSegment, CustomerSegmentLabels);
export const CUSTOMER_CONTRACT_STATUS_ICON = {
  [CustomerContractStatus.ACTIVE]: 'CircleCheck',
  [CustomerContractStatus.PENDING]: 'Clock',
  [CustomerContractStatus.TERMINATED]: 'Archive',
  [CustomerContractStatus.CANCELLED]: 'CircleX'
} as const satisfies Record<CustomerContractStatus, string>;

export const CUSTOMER_CONTRACT_STATUS_LABEL_MAP = getLabelMapFromEntries(
  CustomerContractStatus,
  CustomerContractStatusLabels
);
const CUSTOMER_CONTRACT_STATUS_DESCRIPTION_MAP = getLabelMapFromEntries(
  CustomerContractStatus,
  CustomerContractStatusDescriptions
);
export const CUSTOMER_CONTRACT_STATUS_OPTIONS = entriesToOptions(
  CustomerContractStatus,
  CustomerContractStatusLabels
).map((option) => ({
  ...option,
  icon: CUSTOMER_CONTRACT_STATUS_ICON[option.value],
  description: CUSTOMER_CONTRACT_STATUS_DESCRIPTION_MAP[option.value]
}));
export const CUSTOMER_CONTRACT_TYPE_LABEL_MAP = getLabelMapFromEntries(
  CustomerContractType,
  CustomerContractTypeLabels
);
export const TIRE_HOTEL_REHOME_STATUS_ICON = {
  [TireHotelRehomeStatus.DRAFT]: 'FileText',
  [TireHotelRehomeStatus.PENDING_BUYER]: 'Send',
  [TireHotelRehomeStatus.COMPLETED]: 'CircleCheck',
  [TireHotelRehomeStatus.REJECTED]: 'CircleX',
  [TireHotelRehomeStatus.EXPIRED]: 'CalendarX',
  [TireHotelRehomeStatus.CANCELLED]: 'X'
} as const satisfies Record<TireHotelRehomeStatus, string>;
export const TIRE_HOTEL_REHOME_STATUS_LABEL_MAP = getLabelMapFromEntries(
  TireHotelRehomeStatus,
  TireHotelRehomeStatusLabels
);
export const TIRE_HOTEL_REHOME_STATUS_OPTIONS = entriesToOptions(
  TireHotelRehomeStatus,
  TireHotelRehomeStatusLabels
).map((option) => ({
  ...option,
  icon: TIRE_HOTEL_REHOME_STATUS_ICON[option.value]
}));
export const TIRE_HOTEL_WHEEL_SET_STATUS_ICON = {
  [TireHotelWheelSetStatus.AWAITING_INBOUND]: 'Clock',
  [TireHotelWheelSetStatus.PICKUP_SCHEDULED]: 'CalendarClock',
  [TireHotelWheelSetStatus.NEVER_COLLECTED]: 'PackageMinus',
  [TireHotelWheelSetStatus.IN_TRANSIT]: 'Truck',
  [TireHotelWheelSetStatus.IN_STORAGE]: 'Warehouse',
  [TireHotelWheelSetStatus.WITH_CUSTOMER]: 'User',
  [TireHotelWheelSetStatus.UNKNOWN]: 'CircleHelp'
} as const satisfies Record<TireHotelWheelSetStatus, string>;
/** Keyed by the wire value ("navio"), which is what records carry. */
export const INSPECTION_SOURCE_LABEL_MAP = getLabelMapFromEntries(InspectionSource, InspectionSourceLabels);
export const INSPECTION_CONTEXT_LABEL_MAP = getLabelMapFromEntries(InspectionContext, InspectionContextLabels);
export const INSPECTION_PURPOSE_LABEL_MAP = getLabelMapFromEntries(InspectionPurpose, InspectionPurposeLabels);
export const CAR_WHEEL_MEASUREMENT_TYPE_OPTIONS = entriesToOptions(
  CarWheelMeasurementType,
  CarWheelMeasurementTypeLabels
);
export const INSPECTION_SOURCE_OPTIONS = entriesToOptions(InspectionSource, InspectionSourceLabels);
export const INSPECTION_CONTEXT_OPTIONS = entriesToOptions(InspectionContext, InspectionContextLabels);
export const INSPECTION_PURPOSE_OPTIONS = entriesToOptions(InspectionPurpose, InspectionPurposeLabels);
export const TIRE_HOTEL_WHEEL_SET_STATUS_LABEL_MAP = getLabelMapFromEntries(
  TireHotelWheelSetStatus,
  TireHotelWheelSetStatusLabels
);
export const TIRE_HOTEL_WHEEL_SET_STATUS_DESCRIPTION_MAP = getLabelMapFromEntries(
  TireHotelWheelSetStatus,
  TireHotelWheelSetStatusDescriptions
);
export const TIRE_HOTEL_REHOME_SELLER_MEMBERSHIP_OUTCOME_LABEL_MAP = getLabelMapFromEntries(
  TireHotelRehomeSellerMembershipOutcome,
  TireHotelRehomeSellerMembershipOutcomeLabels
);
export const TIRE_HOTEL_REHOME_SETTLEMENT_LABEL_MAP = getLabelMapFromEntries(
  TireHotelRehomeSettlement,
  TireHotelRehomeSettlementLabels
);
export const TIRE_HOTEL_SELLER_INBOUND_MODE_LABEL_MAP = getLabelMapFromEntries(
  TireHotelSellerInboundMode,
  TireHotelSellerInboundModeLabels
);
export const TIRE_HOTEL_SELLER_INBOUND_MODE_OPTIONS = entriesToOptions(
  TireHotelSellerInboundMode,
  TireHotelSellerInboundModeLabels
);

// Phone number
export const PHONE_NUMBER_TYPE_OPTIONS = entriesToOptions(PhoneNumberType, PhoneNumberTypeLabels).map((opt) => ({
  ...opt,
  label: opt.label.charAt(0).toUpperCase() + opt.label.slice(1)
}));
export const PHONE_NUMBER_COUNTRY_OPTIONS = entriesToOptions(PhoneNumberCountry, PhoneNumberCountryLabels).map(
  (opt) => {
    const flag = countryCodeToFlag(opt.value);
    return { ...opt, label: flag ? `${flag} ${opt.label}` : opt.label };
  }
);

// Email
export const EMAIL_PROVIDER_OPTIONS = entriesToOptions(EmailProvider, EmailProviderLabels);
export const EMAIL_STATUS_OPTIONS = entriesToOptions(EmailStatus, EmailStatusLabels);
export const EMAIL_TEMPLATE_OPTIONS = entriesToOptions(EmailTemplate, EmailTemplateLabels);
// MimeType has no const object or labels in nsdk; hardcoded but centralized here
export const MIME_TYPE_OPTIONS: { value: NsdkMimeType; label: string }[] = (
  [
    'text/plain',
    'text/html',
    'text/csv',
    'text/calendar',
    'text/svg',
    'application/json',
    'application/pdf',
    'application/xml',
    'application/xhtml+xml',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/svg+xml',
    'image/avif'
  ] satisfies NsdkMimeType[]
).map((value) => ({
  value,
  label: value.replace(/^[^/]+\//, '').replace(/^([a-z]+)/, (_, s: string) => s.toUpperCase())
}));

// Tire & rim
export const TIRE_CLASS_EU_OPTIONS = entriesToOptions(TireClassEU, TireClassEULabels);
export const TIRE_CLASSIFICATION_OPTIONS = entriesToOptions(TireClassification, TireClassificationLabels);
export const TIRE_CONSTRUCTION_TYPE_OPTIONS = entriesToOptions(TireConstructionType, TireConstructionTypeLabels);
export const TIRE_LOAD_INDEX_OPTIONS = enumToOptions(TireLoadIndex, TireLoadIndexLabels).map((o) => ({
  value: String(o.value),
  label: `${o.value} (${o.label} kg)`
}));
export const TIRE_ROLLING_RESISTANCE_CLASS_OPTIONS = entriesToOptions(
  TireRollingResistanceClass,
  TireRollingResistanceClassLabels
);
export const TIRE_SEASON_OPTIONS = entriesToOptions(TireSeason, TireSeasonLabels).map((option) => ({
  ...option,
  icon: TIRE_SEASON_ICON[option.value]
}));
export const VEHICLE_CATEGORY_OPTIONS = entriesToOptions(VehicleCategory, VehicleCategoryLabels);
export const TIRE_SPEED_INDEX_OPTIONS = entriesToOptions(TireSpeedIndex, TireSpeedIndexLabels).map((o) => ({
  value: o.value,
  label: `${o.value} (${o.label} km/h)`
}));
export const SOUND_CLASS_OPTIONS = entriesToOptions(SoundClass, SoundClassLabels);
export const WET_GRIP_CLASS_OPTIONS = entriesToOptions(WetGripClass, WetGripClassLabels);
export const RIM_COLOR_FINISH_OPTIONS = entriesToOptions(RimColorFinish, RimColorFinishLabels);
export const RIM_ITEM_NOTE_OPTIONS = entriesToOptions(RimItemNote, RimItemNoteLabels);

// Currency
const CURRENCY_SYMBOLS: Record<Currency, string> = {
  [Currency.CAD]: 'C$',
  [Currency.EUR]: '€',
  [Currency.NOK]: 'kr',
  [Currency.SEK]: 'kr',
  [Currency.USD]: '$'
};

export const CURRENCY_OPTIONS = entriesToOptions(Currency, CurrencyLabels).map((option) => ({
  ...option,
  label: `${CURRENCY_SYMBOLS[option.value]} ${option.label}`
}));

// Task & rule set
export const TASK_TYPE_OPTIONS = entriesToOptions(TaskType, TaskTypeLabels);
export const RULE_SET_CATEGORY_OPTIONS = entriesToOptions(RuleSetCategory, RuleSetCategoryLabels);

// Audit log (custom labels - nsdk's AuditLogActionLabels has numeric string values)
const AUDIT_LOG_ACTION_LABELS: Record<AuditLogAction, string> = {
  [AuditLogAction.CREATE]: 'Create',
  [AuditLogAction.UPDATE]: 'Update',
  [AuditLogAction.DELETE]: 'Delete',
  [AuditLogAction.ACCESS]: 'Access'
};
export const AUDIT_LOG_ACTION_OPTIONS = enumToOptions(AuditLogAction, AUDIT_LOG_ACTION_LABELS);

// Lead generation (using nsdk types)
export const LEAD_STAGE_OPTIONS = entriesToOptions(LeadStage, LeadStageLabels);

export const LEAD_CLOSE_REASON_OPTIONS = entriesToOptions(LeadCloseReason, LeadCloseReasonLabels);
export const LEAD_GENERATION_TYPE_OPTIONS = entriesToOptions(LeadGenerationType, LeadGenerationTypeLabels);

// Payment — short labels for tables/filters
export const PAYMENT_OPTION_SHORT_LABELS: Record<PaymentOption, string> = {
  INVOICE: 'Invoice',
  PAY_BEFORE: 'Pay in advance',
  PAY_AFTER: 'Pay after order is fulfilled'
};
export const PAYMENT_METHOD_OPTIONS = entriesToOptions(PaymentOption, PAYMENT_OPTION_SHORT_LABELS);
export const QUOTE_ITEM_STATUS_OPTIONS = constObjectToSentenceCaseOptions(QuoteStatus);

// SMS (nsdk labels are snake_case values, so we format them ourselves)
export const BOOKING_SMS_TYPE_OPTIONS = constObjectToSentenceCaseOptions(BookingSMSType);
export const SMS_TYPE_OPTIONS = [
  ...constObjectToSentenceCaseOptions(BookingProposalSMSType),
  ...BOOKING_SMS_TYPE_OPTIONS,
  ...constObjectToSentenceCaseOptions(ServiceWorkerSMSType),
  ...constObjectToSentenceCaseOptions(TireQuoteSMSType),
  ...constObjectToSentenceCaseOptions(UserGroupSMSType)
].sort((a, b) => a.label.localeCompare(b.label));

// Service worker
export const SERVICE_WORKER_EMPLOYMENT_TYPE_OPTIONS = constObjectToSentenceCaseOptions(
  ServiceWorkerContractEmploymentType
);
/**
 * Contract types a department offers, from its backend `selectableEmploymentTypes`. `keep` stays listed so a
 * contract whose type the department stopped offering still shows its current value.
 */
export const getSelectableEmploymentTypeOptions = (
  selectable: readonly ServiceWorkerContractEmploymentType[],
  keep?: ServiceWorkerContractEmploymentType
) => SERVICE_WORKER_EMPLOYMENT_TYPE_OPTIONS.filter(({ value }) => selectable.includes(value) || value === keep);
export const SERVICE_WORKER_EMPLOYMENT_TYPE_LABELS: Record<ServiceWorkerContractEmploymentType, string> = {
  EMPLOYEE_HOURLY_PAY: 'Hourly pay',
  EMPLOYEE_FIXED_PAY: 'Fixed pay',
  FREELANCE: 'Freelance',
  SUBCONTRACTOR: 'Subcontractor'
};
export const SERVICE_WORKER_ABSENCE_TYPE_OPTIONS = entriesToOptions(
  ServiceWorkerAbsenceType,
  ServiceWorkerAbsenceTypeLabels
);

// Value-keyed label/description maps: the SDK's `*Labels` / `*Descriptions`
// consts are keyed by enum *name* (`SICK_CHILD`), but records carry the enum
// *value* (`"sick_child"`), so invert via getLabelMapFromEntries for direct
// `MAP[absence.absenceType]` lookups.
export const SERVICE_WORKER_ABSENCE_TYPE_LABEL_BY_VALUE = getLabelMapFromEntries(
  ServiceWorkerAbsenceType,
  ServiceWorkerAbsenceTypeLabels
);
export const SERVICE_WORKER_ABSENCE_TYPE_DESCRIPTION_BY_VALUE = getLabelMapFromEntries(
  ServiceWorkerAbsenceType,
  ServiceWorkerAbsenceTypeDescriptions
);
export const SERVICE_WORKER_ABSENCE_STATUS_LABEL_BY_VALUE = getLabelMapFromEntries(
  ServiceWorkerAbsenceStatus,
  ServiceWorkerAbsenceStatusLabels
);
export const FLEET_AUTO_BOOKING_SKIP_REASON_LABEL_BY_VALUE = getLabelMapFromEntries(
  FleetAutoBookingSkipReason,
  FleetAutoBookingSkipReasonLabels
);

// SMS statuses (replaces getSMSStatuses API call)
export const SMS_STATUS_OPTIONS = constObjectToSentenceCaseOptions(TwilioStatusCode);

// Webhook event types (replaces getOutboundWebhookEventTypes API call)
export const OUTBOUND_WEBHOOK_EVENT_TYPE_OPTIONS = entriesToOptions(
  OutboundWebhookEventType,
  OutboundWebhookEventTypeLabels
);

// Capacity contribution (replaces getCapacityContributionStatuses/Types API calls)
export const CAPACITY_CONTRIBUTION_LOCATION_TYPE_OPTIONS = entriesToOptions(
  CapacityContributionLocationType,
  CapacityContributionLocationTypeLabels
);
export const CAPACITY_CONTRIBUTION_STATUS_OPTIONS = enumToOptions(
  CapacityContributionStatus,
  CapacityContributionStatusLabels
);
/**
 * UI names for the two supply kinds. The generated labels say "Personal" and "Baseline";
 * end users are told "Worker shift" and "Expected staffing" everywhere, so this map — not
 * `CapacityContributionTypeLabels` — is what any label, filter or badge must read from.
 */
export const CAPACITY_CONTRIBUTION_TYPE_UI_LABELS: Record<CapacityContributionType, string> = {
  [CapacityContributionType.PERSONAL]: 'Worker shift',
  [CapacityContributionType.BASELINE]: 'Expected staffing'
};

// User roles (replaces getUserRoles API call)
export const USER_ROLE_OPTIONS = entriesToOptions(UserRole, UserRoleLabels);

export const LANGUAGE_CODE_OPTIONS = entriesToOptions(LanguageCode, LanguageCodeLabels);

// Support schedule
export const SUPPORT_SCHEDULE_CADENCE_OPTIONS = entriesToOptions(SupportScheduleCadence, SupportScheduleCadenceLabels);
export const SUPPORT_SCHEDULE_SELECTION_STRATEGY_OPTIONS = entriesToOptions(
  SupportScheduleSelectionStrategy,
  SupportScheduleSelectionStrategyLabels
);

// Opening hours
export const OPENING_HOURS_EXCEPTION_RECURRING_VALUES = ['NONE', 'WEEKLY_DATE', 'MONTHLY_DATE', 'YEARLY_DATE'] as const;

const OPENING_HOURS_EXCEPTION_RECURRING_LABELS: Record<
  (typeof OPENING_HOURS_EXCEPTION_RECURRING_VALUES)[number],
  string
> = {
  NONE: 'None',
  WEEKLY_DATE: 'Weekly',
  MONTHLY_DATE: 'Monthly',
  YEARLY_DATE: 'Yearly'
};

export type OpeningHoursExceptionRecurring = (typeof OPENING_HOURS_EXCEPTION_RECURRING_VALUES)[number];

export const OPENING_HOURS_EXCEPTION_RECURRING_OPTIONS = OPENING_HOURS_EXCEPTION_RECURRING_VALUES.map((value) => ({
  value,
  label: OPENING_HOURS_EXCEPTION_RECURRING_LABELS[value]
}));

export const OPENING_HOURS_EXCEPTION_RECURRING_LABEL_MAP = OPENING_HOURS_EXCEPTION_RECURRING_LABELS;

export const OPENING_HOURS_WEEKDAY_OPTIONS = [
  { value: 0, label: 'Monday' },
  { value: 1, label: 'Tuesday' },
  { value: 2, label: 'Wednesday' },
  { value: 3, label: 'Thursday' },
  { value: 4, label: 'Friday' },
  { value: 5, label: 'Saturday' },
  { value: 6, label: 'Sunday' }
] as const;

// Payroll
export const PAYROLL_STATUS_OPTIONS = (Object.keys(PayrollStatus) as (keyof typeof PayrollStatus)[]).map((key) => ({
  value: PayrollStatus[key],
  label: PayrollStatusLabels[key]
}));

// Brand availability (const + labels not reliably re-exported from @navio/nsdk at runtime)
export const BRAND_AVAILABILITY_OPTIONS: { label: string; value: string }[] = [
  { label: 'Open', value: 'open' },
  { label: 'Closed', value: 'closed' },
  { label: 'Maintenance', value: 'maintenance' },
  { label: 'Temporary problems', value: 'temporary_problems' }
];
